module.exports = "http://cdn.realive.com.ua/src/views/games/other/images/maps/tanks1.png";